import React, { useEffect, useState } from "react";
import "./niaSimulator.scss";
import EditIcon from "@mui/icons-material/Edit";
import { numberFormatter } from "../../utils";
import CheckIcon from "@mui/icons-material/Check";
import { Button } from "rsuite";

const SpendShift = (props: any) => {
	const {
		oppEq,
		step1 = [],
		step2 = [],
		benifitEq,
		kpi,
		rebateData,
	} = props?.data;
	const {
		nextTierSpend,
		additionalPurchases,
		spendMovement,
		foreCastedSpend,
		isZeroPurchase,
	} = props?.niaSimulatorChangingData;
	const {
		spendMovementSumHandler,
		updateStep1,
		updateStep2,
		onCalculateNIA,
		onSave,
		isCalculated,
		spendText,
		moreDetails,
	} = props;

	const [step1ChangedData, setStep1ChangedData] = useState([]);
	const [step2ChangedData, setStep2ChangedData] = useState([]);
	const [updatedSpend, setUpdatedSpend] = useState<any>([]);
	const [step1TableData, setStep1TableData] = useState(step1);
	const [step2TableData, setStep2TableData] = useState(step2);

	const [remainingSpend, setRemainingSpend] = useState(0);
	const [costPropotion, setCostPropotion] = useState(
		benifitEq?.addtionalInventoryCarryingCostProportion
	);

	const [totalSpend, setTotalSpend] = useState(0);
	useEffect(() => {
		if (Object.keys(props.niaSimulatorData).length > 0) {
			let n: any = Object.values(props.niaSimulatorData).reduce(
				(a: any, b: any) => {
					return a + b;
				},
				0
			);
			setTotalSpend(n);
		}
	}, [props.niaSimulatorData]);

	useEffect(() => {
		setStep1TableData(step1);
	}, [step1]);

	useEffect(() => {
		let res = step2?.reduce(function (acc: number, obj: any) {
			return acc + obj?.spend;
		}, 0);

		let step2Data = JSON.parse(JSON.stringify(step2));

		step2Data?.forEach((value: any) => {
			value.adjDistricProportionBasedOnCompletedQtySpend =
				value.adjDistricProportionBasedOnCompletedQtySpend * 100;
		});

		// let res1 = step2Data?.reduce(function (acc: number, obj: any) {
		//   return acc + obj?.adjIncreaseSpend;
		// }, 0);
		setStep2TableData(step2Data);
		// setRemainingSpend((additionalPurchases)?.toFixed(1) - res1?.toFixed(1));
	}, [step2]);

	// useEffect(() => {
	//   let res1 = step2TableData?.reduce(function (acc: number, obj: any) {
	//     return acc + obj?.adjIncreaseSpend;
	//   }, 0);
	//   // setStep2TableData(step2TableData);
	//   // setRemainingSpend((additionalPurchases)?.toFixed(1) - res1?.toFixed(1));
	// }, [step2TableData]);

	const onStep1SpendChangeHandler = (data: any) => {
		let changeData = JSON.parse(JSON.stringify(step1ChangedData));

		let step1Table = JSON.parse(JSON.stringify(step1TableData));
		let indexTable = step1Table[data?.index]?.tableData.findIndex(
			(value: any) => value?.peer_vendor_name === data?.peer_vendor_name
		);

		if (indexTable !== -1) {
			step1Table[data?.index].tableData[indexTable].adjSpendToBemoved =
				parseFloat(data?.newValue);
			setStep1TableData(step1Table);
		}

		let index = changeData.findIndex(
			(value: any) => value?.peer_vendor_name === data?.peer_vendor_name
		);

		if (index !== -1) {
			changeData[index].adjSpendToBemoved =
				data?.newValue !== "" ? parseFloat(data?.newValue) : 0;
			changeData[index].isValid =
				parseFloat(data?.newValue) > data?.spend ? false : true;
		} else {
			changeData.push({
				spend: data?.spend,
				peer_vendor_name: data?.peer_vendor_name,
				spendToBemoved: data?.spendToBemoved,
				adjSpendToBemoved:
					data?.newValue !== "" ? parseFloat(data?.newValue) : 0,
				isValid:
					parseFloat(data?.newValue) > data?.spend ? false : true,
			});
		}

		setStep1ChangedData(changeData);
	};

	const onStep2SpendChangeHandler = (data: any) => {
		console.log(data);
		let indexTable = data?.index;
		setUpdatedSpend([...updatedSpend, indexTable]);
		let step2Table = JSON.parse(JSON.stringify(step2TableData));
		// let indexTable = step2Table?.findIndex(
		//   (value: any) => value?.districtName === data?.districtName
		// );

		if (indexTable !== -1) {
			step2Table[
				indexTable
			].adjDistricProportionBasedOnCompletedQtySpend = Number(
				data?.newValue
			);
			step2Table[indexTable].isupdated = true;
		}
		let remainingSpend = 0;

		step2Table?.forEach((value: any, index: number) => {
			if (value?.isupdated) {
				remainingSpend += value?.spend * (Number(data?.newValue) / 100);
			}
		});

		remainingSpend = additionalPurchases - remainingSpend;
		console.log(foreCastedSpend, additionalPurchases, remainingSpend, 123);
		let overallRatio = 0;
		step2Table?.forEach((value: any, index: number) => {
			value.spendRatio = value?.spend / foreCastedSpend;
			if (index !== indexTable && !value?.isupdated) {
				overallRatio += value?.spendRatio;
			}
		});

		step2Table?.forEach((value: any, index: number) => {
			if (index !== indexTable && !value?.isupdated) {
				let newRatio = value?.spendRatio / overallRatio;
				let additionalSpend = remainingSpend * newRatio;
				value.adjDistricProportionBasedOnCompletedQtySpend = Math.floor(
					(additionalSpend / value?.spend) * 100
				);
				console.log(
					Math.floor((additionalSpend / value?.spend) * 100),
					(additionalSpend / value?.spend) * 100
				);
			}
		});

		// let totalQTYSpend=0
		// step2Table?.forEach((value: any,index:any) => {

		//   totalQTYSpend+=value?.districProportionBasedOnCompletedQtySpend

		// })

		// // let sumOfRemaingPercentage=100-Number(data?.newValue)
		// let sumOfRemaingPercentage = 0;
		// step2Table?.forEach((value: any, index: number) => {
		//   if (value?.isupdated) {
		//     sumOfRemaingPercentage +=
		//       value?.adjDistricProportionBasedOnCompletedQtySpend;
		//   }
		// });
		// sumOfRemaingPercentage = (totalQTYSpend*100) - sumOfRemaingPercentage;

		// console.log(sumOfRemaingPercentage,'sumOfRemaingPercentage')

		// let notUpdatedCount=0
		// step2Table?.forEach((value: any,index:any) => {
		//   if (index !== indexTable && !value?.isupdated) {
		//     notUpdatedCount+=1
		//   }
		// })

		// console.log(notUpdatedCount,'notupdate')
		// step2Table?.forEach((value: any, index: number) => {
		//   if (index !== indexTable && !value?.isupdated) {
		//     value.adjDistricProportionBasedOnCompletedQtySpend = (sumOfRemaingPercentage/notUpdatedCount).toFixed(0);
		//   }
		// });
		setStep2TableData(step2Table);
		setStep2ChangedData(step2Table);
		props.updateIsCalculated(false);
	};

	useEffect(() => {
		if (step1ChangedData?.length > 0) {
			spendMovementSumHandler(step1ChangedData);
		}
	}, [step1ChangedData]);

	useEffect(() => {
		if (step1ChangedData?.length > 0) {
			updateStep1(step1TableData);
		}
	}, [step1ChangedData]);

	useEffect(() => {
		if (step2ChangedData?.length > 0) {
			updateStep2(step2TableData);
		}
	}, [step2ChangedData]);

	const onStep2SpendEditHandler = (data: any) => {
		let step2Table = JSON.parse(JSON.stringify(step2TableData));
		let indexTable = step2Table?.findIndex(
			(value: any) => value?.districtName === data?.districtName
		);

		if (indexTable !== -1) {
			step2Table[indexTable].isEdit = step2Table[indexTable]?.isEdit
				? false
				: true;
			setStep2TableData(step2Table);
		}
		setStep2ChangedData(step2Table);
	};

	const onStep1SpendEditHandler = (data: any) => {
		let step1Table = JSON.parse(JSON.stringify(step1TableData));
		let indexTable = step1Table[data?.index]?.tableData.findIndex(
			(value: any) => value?.peer_vendor_name === data?.peer_vendor_name
		);

		if (indexTable !== -1) {
			step1Table[data?.index].tableData[indexTable].isEdit = step1Table[
				data?.index
			].tableData[indexTable].isEdit
				? false
				: true;
			setStep1TableData(step1Table);
		}
	};

	return (
		<div className="snap-scroll-container snap-y snap-mandatory gap-y-[2vw] flex flex-col mt-[0.8vh] scroll-smooth">
			{/* <div className="w-full h-[3dvw]  flex justify-center items-center">
				<div className="textL text-black mx-2">{`[`}</div>
				<div
					className={`bg-white rounded-sm shadow-sm border-[0.5px] border-lightGrey w-[25%] h-[100%] px-[0.6vw] flex flex-col justify-between items-start }`}
				>
					<div className="font-bold text-black capitalize text-left text-fs14 leading-normal">
						{spendText} required for next tier
					</div>
					<div className="text-[#046A38] font-semibold text-fs20 leading-normal">
						{numberFormatter(nextTierSpend, 0)}
					</div>
				</div>

				<div className="textL text-black mx-1">-</div>

				<div
					className={`bg-white rounded-sm shadow-sm border-[0.5px] border-lightGrey w-[25%] h-[100%] px-[0.6vw] py-[1.1vh] flex flex-col justify-between items-start "}`}
				>
					<div className="font-bold text-black capitalize text-left text-fs14 leading-normal">
						Forecasted {spendText} based on YTD growth
					</div>
					<div className="text-[#86BC25] font-semibold text-fs20 leading-normal">
						{numberFormatter(foreCastedSpend, 0)}
					</div>
				</div>

				<div className="textL text-black mx-1">-</div>
				<div
					className={`bg-white rounded-sm shadow-sm border-[0.5px] border-lightGrey w-[25%] h-[100%] px-[0.6vw] py-[1.1vh] flex flex-col justify-between items-start`}
				>
					<div className="font-bold text-black capitalize text-left text-fs14 leading-normal">
						{spendText} Movement from Peers
					</div>
					<div className="text-[#86BC25] font-semibold text-fs20 leading-normal">
						{numberFormatter(spendMovement, 0)}
					</div>
				</div>
				<div className="div"></div>
				<div className="textL text-black mx-2">{`]`}</div>
				<div className="textL text-black">=</div>

				<div
					className={`bg-white rounded-sm shadow-sm border-[0.5px] border-lightGrey w-[25%] h-[100%] px-[0.6vw] py-[1.1vh] flex flex-col justify-between items-start"}`}
				>
					<div className="font-bold text-black capitalize text-left text-fs14 leading-normal">
						{rebateData?.master_vendor_name === "BERK TEK"
							? "Additional Sales Required"
							: "Additional Purchases Required"}
					</div>
					<div className="text-[#86BC25] font-semibold text-fs20 leading-normal">
						{numberFormatter(additionalPurchases, 0)}
					</div>
				</div>
			</div> */}

			<div
				className={`snap-child flex flex-col justify-between ${
					moreDetails ? "" : ""
				}`}
			>
				<div className={`summary compressedSummary flex items-center gap-2 h-[15vh] mt-[4vh]`}>
					<div className="textL text-black">[</div>

					<div className="card">
						<span className="header">
							{spendText} Required for Next Tier
						</span>
						<div className="bottom">
							{numberFormatter(nextTierSpend, 0)}
						</div>
					</div>

					<div className="textL text-black">-</div>

					<div className="card">
						<span className="header">
							Forecasted {spendText} (YTD Growth)
						</span>
						<div className="bottom">
							{numberFormatter(foreCastedSpend, 0)}
						</div>
					</div>

					<div className="textL text-black">-</div>

					<div className="card">
						<span className="header">
							{spendText} Movement from Peers
						</span>
						<div className="bottom">
							{numberFormatter(spendMovement, 0)}
						</div>
					</div>

					<div className="textL text-black">]</div>
					<div className="textL text-black">=</div>

					<div className="card">
						<span className="header">
							{rebateData?.master_vendor_name === "BERK TEK"
								? "Additional Sales Required"
								: "Additional Purchases Required"}
						</span>
						<div className="bottom">
							{numberFormatter(additionalPurchases, 0)}
						</div>
					</div>
				</div>

				<div
				className={`snap-child ${
					moreDetails ? "" : "hidden"
				}`}
				>
					{isZeroPurchase && (
						<div className=" flex justify-center mt-[8vw] items-center italic font-bold text-[2.5vh] text-black ">
							<h1>No Additional Purchases required</h1>
						</div>
					)}

					{!isZeroPurchase && (
						<div className="flex h-full gap-x-[1vw]">
							<div className="w-full mt-[1vh]">
								{/* Step 1 Table Header */}
								<div className="common-table-header-row !mb-0">
									<div className="common-table-header">
										Step-1: By Shifting {spendText} from Peers
									</div>
								</div>
								{/* Step 1 Table */}
								<div className="h-[32vh] w-full">
									<table className="common-table-ui w-[100%]">
										<thead>
											<tr>
												<th className="w-[10%]">
													Category
												</th>
												<th className="w-[30%]">
													Supplier
												</th>
												<th className="w-[10%]">
													{spendText} ($)​
												</th>
												<th className="w-[20%]">
													Effective NIA Rebate (%)
												</th>
												<th className="w-[10%]">
													Comparable {spendText}
												</th>
												<th className="w-[10%]">
													{spendText} ($) To Be Moved
												</th>
												<th>Action</th>
											</tr>
										</thead>
										<tbody>
											{step1TableData?.map(
												(element: any, index: any) => {
													return (
														<>
															{element?.tableData?.map(
																(
																	value: any,
																	index1: any
																) => {
																	return (
																		<tr
																			key={
																				index1
																			}
																			className={`${
																			value?.adjSpendToBemoved > value?.spend
																				? "text-red-500"
																				: "text-white"
																			} `}
																		>
																			<td>
																				{
																					element?.categoryName
																				}
																			</td>
																			<td>
																				{
																					value?.peer_vendor_name
																				}
																			</td>
																			<td>
																				{numberFormatter(
																					value?.spend,
																					0
																				)}
																			</td>
																			<td>
																				{(
																					value?.effectiveNiaRebate *
																					100
																				)?.toFixed(
																					2
																				)}
																				%
																			</td>
																			<td>
																				{numberFormatter(
																					value?.comparableSpend,
																					0
																				)}
																			</td>
																			<td>
																				{value?.isEdit && (
																					<input
																						// onClick={(e) => e.stopPropagation()}
																						type="number"
																						onChange={(
																							e
																						) =>
																							onStep1SpendChangeHandler(
																								{
																									...value,
																									newValue:
																										e
																											?.target
																											?.value,
																									index: index,
																								}
																							)
																						}
																						// key={value?.adjSpendToBemoved}
																						value={
																							value?.adjSpendToBemoved
																						}
																						className="adjustedPriceInput"
																					/>
																				)}
																				{!value?.isEdit && (
																					<span>
																						{numberFormatter(
																							value?.adjSpendToBemoved
																						)}
																					</span>
																				)}
																			</td>
																			<td>
																				{!value?.isEdit && (
																					<EditIcon
																						className="cursor-pointer editIcon hover:text-green-400"
																						onClick={() => {
																							onStep1SpendEditHandler(
																								{
																									...value,
																									index: index,
																								}
																							);
																						}}
																					/>
																				)}
																				{value?.isEdit && (
																					<CheckIcon
																						className="cursor-pointer editIcon hover:text-green-400"
																						onClick={() => {
																							onStep1SpendEditHandler(
																								{
																									...value,
																									index: index,
																								}
																							);
																						}}
																					/>
																				)}
																			</td>
																		</tr>
																	);
																}
															)}
														</>
													);
												}
											)}
										</tbody>
									</table>
								</div>
							</div>

							<div className="w-full mt-[1vh]">
								{/* Step 2 Table Header */}
								<div className="common-table-header-row !mb-0">
									<div className="common-table-header">
										Step 2: By Increasing Market Share
									</div>
								</div>
								{/* Step 2 Table */}
								<div className="h-[32vh] w-[100%]">
									{step2 && (
										<table className="common-table-ui w-[100%]">
											<thead>
												<tr>
													<th className="w-[35%]">
														District
													</th>
													<th className="w-[35%]">
														{spendText} ($)​​
													</th>
													<th className="w-[35%]">
														Increase {spendText} by (%)
													</th>
													<th className="w-[35%]">
														Action
													</th>
												</tr>
											</thead>
											<tbody>
												{step2TableData?.map(
													(
														element: any,
														index: number
													) => {
														return (
															<tr className="text-black">
																<td>
																	{
																		element?.districtName
																	}
																</td>
																<td>
																	{numberFormatter(
																		element?.spend,
																		0
																	)}
																</td>
																<td>
																	{element?.isEdit && (
																		<input
																			// onClick={(e) => e.stopPropagation()}
																			type="number"
																			// key={element?.adjIncreaseSpend}
																			onChange={(
																				e
																			) =>
																				onStep2SpendChangeHandler(
																					{
																						...element,
																						newValue:
																							e
																								?.target
																								?.value,
																						index: index,
																					}
																				)
																			}
																			value={
																				element?.adjDistricProportionBasedOnCompletedQtySpend
																			}
																			className="adjustedPriceInput"
																		/>
																	)}
																	{!element?.isEdit && (
																		<span>
																			{numberFormatter(
																				element?.adjDistricProportionBasedOnCompletedQtySpend,
																				0
																			)}
																			%
																		</span>
																	)}
																</td>
																<td>
																	{!element?.isEdit && (
																		<EditIcon
																			className="cursor-pointer editIcon hover:text-green-400"
																			onClick={() => {
																				onStep2SpendEditHandler(
																					{
																						...element,
																						index: index,
																					}
																				);
																			}}
																		/>
																	)}
																	{element?.isEdit && (
																		<CheckIcon
																			className="cursor-pointer editIcon hover:text-green-400"
																			onClick={() => {
																				onStep2SpendEditHandler(
																					{
																						...element,
																						index: index,
																					}
																				);
																			}}
																		/>
																	)}
																</td>
															</tr>
														);
													}
												)}
											</tbody>
										</table>
									)}
								</div>
							</div>
						</div>
					)}
				</div>
				

				{!isZeroPurchase && (
					<div>
					<div className={`summary compressedSummary flex items-center gap-2 h-[15vh] ${moreDetails ? '' : 'mt-[2vw]'} pl-4`}>
						{/* Card 1: Increase in NIA rebate */}
						<div className="card">
							<span className="header">
								Increase in NIA rebate for{" "}
								{rebateData?.master_vendor_name}
							</span>
							<div className="bottom">
								{numberFormatter(benifitEq?.increaseNiaRebate)}
							</div>
						</div>

						<div className="textL text-black">-</div>

						{/* Card 2: Decrease in NIA rebate for peers */}
						<div className="card">
							<span className="header">
								Decrease in NIA rebate for peer suppliers
							</span>
							<div className="bottom">
								{numberFormatter(
									benifitEq?.decreaseNiaReabteForPeers
								)}
							</div>
						</div>

						<div className="textL text-black">-</div>

						{/* Card 3: Additional Inventory carrying cost */}
						<div className="card">
							<span className="header flex items-center">
								Additional Inventory carrying cost at
								<input
									type="text"
									maxLength={8}
									minLength={8}
									className="w-[2vw] h-[3vh] border border-[#bebebe] pl-1"
									onInput={(e: any) => {
										return (e.target.value =
											e.target.value.replace(
												/[^\d]/g,
												""
											));
									}}
									value={costPropotion}
									defaultValue={
										benifitEq?.addtionalInventoryCarryingCostProportion
									}
									onChange={(e) => {
										props.updateIsCalculated(false);
										setCostPropotion(e.target.value);
										benifitEq.addtionalInventoryCarryingCostProportion =
											Number(e.target.value);
									}}
								/>
								%
							</span>
							<div className="bottom">
								{numberFormatter(
									benifitEq?.addtionalInventoryCarryingCost
								)}
							</div>
						</div>

						<div className="textL text-black">=</div>

						{/* Card 4: Total Benefit */}
						<div className="card">
							<span className="header">Total Benefit</span>
							<div className="bottom">
								{numberFormatter(kpi?.totalBenefit)} |{" "}
								{numberFormatter(
									(kpi?.totalBenefit / totalSpend) * 100,
									0
								)}
								%
							</div>
						</div>

					</div>
						{/* Button group */}
						<div className="relative flex justify-center pl-3">
							{!isCalculated ? (
								<Button
									onClick={onCalculateNIA}
									disabled={
										additionalPurchases < 0 ||
										Number(remainingSpend) !== 0
									}
									className="bg-deloitteGreen text-white hover:bg-deloitteGreen hover:text-white"
								>
									Calculate
								</Button>
							) : (
								<Button
									onClick={onSave}
									className="bg-deloitteGreen text-white hover:bg-deloitteGreen hover:text-white"
								>
									Save
								</Button>
							)}
						</div>
					</div>
				)}
			</div>

			
		</div>
	);
};

export default SpendShift;
